import {
  View,
  Text,
  Image,
  TouchableOpacity,
  Keyboard,
  ImageBackground,
  ScrollView,
  TouchableHighlight,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import CommonTextInputWeb from "../../../../common/CommonTextInputWeb";
import UpgradeModal from "../../Event/UpgradeModal";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { useNotifications } from "../../../../context/NotificationContext";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useAuthProvider } from "../../../../context/AuthContext";
import Tooltip from "react-native-walkthrough-tooltip";
import { useTooltips } from "../../../../context/WalkthroughContext";
import Separator from "../../../../Components/Separator";

function MobileDeviceNavigationHeader({
  createEventTapped,
  btnNotificationTapped,
  btnSettingTapped,
  btnSearchTapped,
  handleNextStepFromCreateEventTooltip,
}: {
  createEventTapped?: () => void;
  btnNotificationTapped: () => void;
  btnSettingTapped: () => void;
  btnSearchTapped: () => void;
  handleNextStepFromCreateEventTooltip: () => void;
}) {
  const styles = useStyles();
  const navigation = useNavigation();
  const { newNotificationCount, setNewNotificationCount } = useNotifications();
  const [storedNotificationCount, setStoredNotificationCount] = useState(0);
  const { isActiveSubscriptionFound } = useAuthProvider();
  const [isUpgrade, setIsUpgrade] = useState(false);

  useEffect(() => {
    const getStoredCount = async () => {
      const storedCount = await AsyncStorage.getItem(
        "challengeNotificationCount"
      );
      if (storedCount) {
        setStoredNotificationCount(parseInt(storedCount, 10));
      }
    };
    getStoredCount();
  }, []);

  useEffect(() => {
    if (
      typeof newNotificationCount === "number" &&
      !isNaN(newNotificationCount)
    ) {
      if (newNotificationCount !== storedNotificationCount) {
        AsyncStorage.setItem(
          "challengeNotificationCount",
          `${newNotificationCount}`
        );
        setStoredNotificationCount(newNotificationCount);
      }
    }
  }, [newNotificationCount, storedNotificationCount]);

  const handleNotificationPress = async () => {
    setStoredNotificationCount(0);
    setNewNotificationCount(0);
    await AsyncStorage.removeItem("challengeNotificationCount");
    btnNotificationTapped();
  };
  const {
    createEventTooltipVisible,
    setTooltipVisible,
    homeTooltipVisible,
    setHomeTooltipVisible,
    setCreateEventTooltipVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();
  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={() => {
          navigateToScreen(navigation, AppScreens.DrawerRoute);
        }}
      >
        <Image
          source={AppImages.icLogos}
          style={{ width: 69, height: 55 }}
          resizeMode="contain"
        />
      </TouchableOpacity>

      {!isActiveSubscriptionFound && (
        <ImageBackground
          source={AppImages.UpgradeBtnBg}
          style={{
            width: 120,
            height: 33,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 10,
            overflow: "hidden",
            shadowColor: "rgba(0, 0, 0, 0.25)",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.25,
            shadowRadius: 4,
            elevation: 4,
          }}
        >
          <TouchableOpacity
            style={styles.upgradeBtn}
            onPress={() => {
              setIsUpgrade(true);
            }}
          >
            <Image
              source={AppImages.vsUpgrade}
              style={{
                width: 35,
                height: 35,
                resizeMode: "contain",
                // position: "absolute",
                // top: -10,
                // left: 7,
              }}
            />
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_12,
                {
                  color: AppColors.white,
                  // position: "absolute",
                  // left: 45,
                },
              ]}
            >
              Upgrade
            </Text>
          </TouchableOpacity>
        </ImageBackground>
      )}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}
      >
        <View style={{ alignSelf: "flex-start" }}>
          <Tooltip
            isVisible={createEventTooltipVisible}
            contentStyle={{
              backgroundColor: AppColors.appBlueColor_3A5175,
              width: 350,
            }}
            displayInsets={{ top: 0, bottom: 0, left: 10, right: 10 }}
            arrowStyle={{
              display: "none",
            }}
            content={
              <ScrollView
                style={{
                  flex: 1,
                }}
              >
                <View
                  style={{
                    backgroundColor: AppColors.appBlueColor_3A5175,
                    padding: 10,
                    flexDirection: "row",
                    gap: 10,
                  }}
                >
                  <View style={{ flex: 1, gap: 10 }}>
                    <View style={{ gap: 10 }}>
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          { color: AppColors.white }, // Set text color for better readability
                        ]}
                      >
                        Create an Event ✨
                      </Text>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        Here’s where the magic happens—set up an event that’s
                        unique to you:
                      </Text>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Choose Event Type:
                        </Text>
                        Pick between a Kall-Out Event (free and open to all) or
                        an Exclusive Event (private and ticketed for exclusive
                        access).
                      </Text>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Customise Your Challenge:
                        </Text>
                        Select the game, choose your console, set the date and
                        time, and decide on a wager (coins or belts) to raise
                        the stakes!
                      </Text>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Add Streaming Options:
                        </Text>
                        Select where to stream—Twitch, YouTube, or Esquadifi’s
                        built-in service for Exclusive Events.
                      </Text>
                      <Text style={AppFontStyle.REGULAR_ANYBODY_12}>
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Invite Opponents:
                        </Text>
                        Send out a challenge to friends or share your event link
                        on social media for anyone to join.
                      </Text>
                      {/* event type */}
                      <View
                        style={{
                          width: 335,
                          height: 235,
                          backgroundColor: AppColors.purple_453B50,
                          paddingHorizontal: 20,
                          paddingVertical: 20,
                          // margin: 30,
                          // alignSelf: "center",
                        }}
                      >
                        <View style={{ flexDirection: "row" }}>
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_20,
                              {
                                flex: 1,
                              },
                            ]}
                          >
                            Event type
                          </Text>
                        </View>
                        <Separator
                          color={AppColors.grayColor_565656}
                          height={2}
                          marginTop={5}
                          marginBottom={0}
                          marginHorizontal={0}
                        />
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,

                            { paddingTop: 5, color: AppColors.gray_C3C3C3 },
                          ]}
                        >
                          Select the type of your event
                        </Text>
                        <View
                          style={{
                            marginVertical: 10,
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            gap: 20,
                          }}
                        >
                          {/* Private Button */}
                          <View style={{ alignItems: "center" }}>
                            <TouchableOpacity
                              style={[
                                {
                                  borderColor: AppColors.appViolentColor_6D08C3,
                                  flexGrow: 1,
                                  padding: 15,
                                  flex: 1,
                                  flexDirection: "row",
                                  backgroundColor:
                                    AppColors.appBlackColor_1e1e1e,
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: 10,
                                  borderWidth: 1,
                                  borderRadius: 10,
                                },
                              ]}
                              onPress={() => {}}
                            >
                              <View
                                style={{
                                  height: 10,
                                  width: 10,
                                  borderRadius: 18,
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  position: "absolute",
                                  top: 5,
                                  left: 7,
                                }}
                              />
                              <Image
                                source={AppImages.icPublic}
                                style={{
                                  height: 100,
                                  width: 100,
                                  resizeMode: "contain",
                                  // margin: 10,
                                }}
                              />
                            </TouchableOpacity>
                            <View>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_14,
                                  {
                                    color: AppColors.white,
                                    textAlign: "center",
                                    marginTop: 5,
                                  },
                                ]}
                              >
                                KALL OUT
                              </Text>
                            </View>
                          </View>

                          {/* Public Button */}
                          <View style={{ alignItems: "center" }}>
                            <TouchableOpacity
                              style={{
                                flexGrow: 1,
                                padding: 15,
                                flex: 1,
                                flexDirection: "row",
                                backgroundColor: AppColors.appBlackColor_1e1e1e,
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: 10,
                                borderColor: AppColors.appBlackColor_1e1e1e,
                                borderWidth: 1,
                                borderRadius: 10,
                              }}
                              onPress={() => {}}
                            >
                              <View
                                style={{
                                  height: 10,
                                  width: 10,
                                  borderRadius: 18,
                                  borderColor: "#454545",
                                  position: "absolute",
                                  top: 5,
                                  left: 7,
                                  borderWidth: 1,
                                }}
                              />
                              <Image
                                source={AppImages.icPrivate}
                                style={{
                                  height: 100,
                                  width: 100,
                                  resizeMode: "contain",
                                  // margin: 10,
                                }}
                              />
                            </TouchableOpacity>
                            <View>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_14,
                                  {
                                    color: AppColors.white,
                                    textAlign: "center",
                                    marginTop: 5,
                                  },
                                ]}
                              >
                                EXCLUSIVE
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        gap: 10,
                      }}
                    >
                      {/* Dots (Step Indicator) */}
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 5,
                          justifyContent: "center",
                          marginBottom: 10,
                        }}
                      >
                        {Array.from({ length: totalSteps }).map((_, index) => (
                          <View
                            key={index}
                            style={{
                              height: 6,
                              width: 6,
                              borderRadius: 5,
                              backgroundColor:
                                currentStep === index
                                  ? AppColors.appViolentColor_6D08C3 // Active step color
                                  : AppColors.white, // Inactive step color
                              borderWidth: 1,
                              borderColor:
                                currentStep === index
                                  ? AppColors.appViolentColor_6D08C3 // Active step color
                                  : AppColors.white,
                            }}
                          />
                        ))}
                      </View>
                      <Text
                        style={{
                          fontFamily: "Anybody_400Regular",
                          fontSize: 12,
                          color: AppColors.green_00FFE8,
                        }}
                      >
                        Click “Next” to start exploring the Home Page.
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          setCreateEventTooltipVisible(false);
                          handleNextStepFromCreateEventTooltip();
                          handleNextStep();
                        }}
                        style={{
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                          width: 70,
                          height: 20,
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 10,
                          cursor: "pointer",
                        }}
                      >
                        <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </ScrollView>
            }
            placement="bottom"
          >
            <TouchableHighlight>
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  backgroundColor: AppColors.appGreenColor_51AF07,
                  height: 32,
                  borderRadius: 5,
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 12,
                  gap: 6,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.25,
                  shadowRadius: 4,
                  elevation: 4,
                }}
                onPress={() => {
                  createEventTapped();
                }}
              >
                <Image
                  source={AppImages.icVectorPlus}
                  style={{
                    width: 12,
                    height: 12,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>
            </TouchableHighlight>
          </Tooltip>
        </View>

        {/* Notification Button */}
        <TouchableOpacity onPress={handleNotificationPress}>
          <View style={{ position: "relative" }}>
            <Image
              source={AppImages.icNotificationBing}
              style={{ width: 27, height: 27, resizeMode: "contain" }}
            />
            {storedNotificationCount > 0 && (
              <View
                style={{
                  position: "absolute",
                  right: -5,
                  top: -9,
                  backgroundColor: AppColors.white,
                  borderRadius: 12,
                  height: 19,
                  width: 18,
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  borderWidth: 1,
                  borderColor: AppColors.black,
                }}
              >
                <Text
                  style={{
                    color: AppColors.red_EA3737,
                    fontSize: 12,
                    fontWeight: "bold",
                  }}
                >
                  {storedNotificationCount}
                </Text>
              </View>
            )}
          </View>
        </TouchableOpacity>

        {/* Setting Button */}
        <TouchableOpacity
          onPress={() => {
            btnSettingTapped();
          }}
          style={
            {
              // padding: 1,
              // backgroundColor: AppColors.gray_1E1E1E,
              // borderRadius: "50%",
            }
          }
        >
          <Image
            source={AppImages.icSetting}
            style={{ width: 27, height: 27 }}
          />
        </TouchableOpacity>

        {/* Search Button */}
        <TouchableOpacity
          onPress={() => {
            btnSearchTapped();
          }}
        >
          <Image
            source={AppImages.icSearchWhite}
            style={{ width: 26, height: 28 }}
          />
        </TouchableOpacity>
      </View>
      {isUpgrade && (
        <UpgradeModal
          showModal={isUpgrade}
          setShowModal={setIsUpgrade}
          eventType={"HomeScreen"}
        />
      )}
      {/* <Text>Mobile</Text> */}
    </View>
  );
}

function SearchScreentNavigationHeader({
  btnSearchTapped,
}: {
  btnSearchTapped: (string) => void;
}) {
  const styles = useStyles();
  const navigation = useNavigation();
  const [searchEvent, setSearchEvent] = useState("");

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={() => {
          navigateToScreen(navigation, AppScreens.Home);
        }}
      >
        <Image
          source={AppImages.KO_LOGO_Main}
          style={{ width: 70, height: 45 }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}
      >
        {/* Search events by name, players, genre or game */}
        <CommonTextInputWeb
          placeholder="Search"
          mainStyle={styles.mainStyle}
          inputStyle={{ margin: 5, padding: 0, paddingHorizontal: 8 }}
          prefixIconVisibility={false}
          onChangeText={setSearchEvent}
          isPassword={false}
          value={searchEvent}
          onSubmitEditing={() => {
            btnSearchTapped(searchEvent);
            Keyboard.dismiss();
          }}
          autoCapitalize="none"
        />

        {/* Search Button */}
        <TouchableOpacity
          onPress={() => {
            btnSearchTapped(searchEvent);
            Keyboard.dismiss();
          }}
        >
          <Image
            source={AppImages.icSearchWhite}
            style={{ width: 26, height: 28 }}
          />
        </TouchableOpacity>
      </View>
      {/* <Text>Mobile</Text> */}
    </View>
  );
}

export { MobileDeviceNavigationHeader, SearchScreentNavigationHeader };

const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 65,
      backgroundColor: AppColors.purple_453B50,
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 10,
    },
    mainStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      height: 35,
      borderRadius: 30,
      borderWidth: 0,
      width: 232,
    },
    upgradeBtn: {
      flexDirection: "row",
      height: 32,
      borderRadius: 5,
      justifyContent: "center",
      alignItems: "center",
      width: "30%",
    },
  },
  {
    [DEVICE_SIZES.SM]: {
      upgradeBtn: {
        width: "22%",
      },
    },
    [DEVICE_SIZES.XS]: {
      upgradeBtn: {
        width: 115,
      },
    },
  }
);
